"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleBasketInputChangedSaga = handleBasketInputChangedSaga;
exports.validateExpressSystemErrorsSaga = validateExpressSystemErrorsSaga;
exports.makeBetSaga = makeBetSaga;
exports.makeBetSuccessSaga = makeBetSuccessSaga;
exports.makeBetErrorSaga = makeBetErrorSaga;
exports.makeBetOrdinar = makeBetOrdinar;
exports.makeBetExpress = makeBetExpress;
exports.makeBetSystem = makeBetSystem;
exports.addOutcomeToBasketSaga = addOutcomeToBasketSaga;
exports.updateBasketOutcomesSaga = updateBasketOutcomesSaga;
exports.deleteBasketSaga = deleteBasketSaga;
exports.deleteBasketOutcomeSaga = deleteBasketOutcomeSaga;
exports.getBasketSaga = getBasketSaga;
exports.processBasketSideEffectsSaga = processBasketSideEffectsSaga;
exports.processBasketPlayersSaga = processBasketPlayersSaga;
exports.setCoefficientStatusOnChangedSaga = setCoefficientStatusOnChangedSaga;
exports.setAppliedCouponSaga = setAppliedCouponSaga;
exports.setBonusWalletSaga = setBonusWalletSaga;
exports.resetAppliedCoupon = resetAppliedCoupon;
exports.handleBetTypeTabChangeSaga = handleBetTypeTabChangeSaga;
exports.handleBetTypeTabChangeMobileSaga = handleBetTypeTabChangeMobileSaga;
exports.basketProviderSaga = basketProviderSaga;
const effects_1 = require("redux-saga/effects");
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const basket_1 = require("../../utils/basket");
const selectors_1 = require("../AccountProvider/selectors");
const format_1 = require("../../utils/format");
const types_1 = require("../ConfigProvider/types");
const selectors_2 = require("../ConfigProvider/selectors");
const selectors_3 = require("../LanguagesProvider/selectors");
const selectors_4 = require("../SearchProvider/selectors");
const selectors_5 = require("../EventsProvider/selectors");
const slice_1 = require("../AccountProvider/slice");
const slice_2 = require("../PlayersProvider/slice");
const slice_3 = require("../StorageProvider/slice");
const utils_1 = require("../../domain/players/utils");
const utils_2 = require("./utils");
const saga_1 = require("../ConfigProvider/saga");
const errors_1 = require("../../utils/errors");
const api_1 = require("../../api/bets/api");
const api_2 = require("../../api/basket/api");
const invariant_1 = require("../../test_utils/invariant");
const basket_2 = require("../../domain/basket");
const slice_4 = require("./slice");
const types_2 = require("./types");
const selectors_6 = require("./selectors");
const validation_1 = require("./validation");
function* handleBasketInputChangedSaga() {
    const validationImprovementsEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.BASKET_VALIDATION_IMPROVEMENTS);
    if (validationImprovementsEnabled) {
        yield (0, validation_1.validateBasketInputSaga)();
    }
    else {
        const isSuccess = yield (0, validation_1.basketValidation)();
        if (isSuccess) {
            yield (0, effects_1.put)(slice_4.basketProviderActions.resetBasketErrors());
            yield (0, effects_1.put)(slice_4.basketProviderActions.resetBasketClientErrors());
        }
    }
}
function* validateExpressSystemErrorsSaga() {
    // reset bonus coupon if we change bet type tab
    yield (0, effects_1.call)(resetAppliedCoupon);
    yield (0, validation_1.basketHandleBetTypeTabChangeMobileErrors)();
}
const makeBetByType = {
    [types_2.EBetTypes.Ordinar]: makeBetOrdinar,
    [types_2.EBetTypes.Express]: makeBetExpress,
    [types_2.EBetTypes.System]: makeBetSystem,
};
function* makeBetSaga() {
    try {
        const accountId = yield (0, effects_1.select)(selectors_1.selectAccountId);
        const currentBetTypeTab = yield (0, effects_1.select)(selectors_6.selectBasketBetTypeTab);
        const bonusWallet = yield (0, effects_1.select)(selectors_6.selectBasketBonusWallet);
        const outcomes = yield (0, effects_1.select)(selectors_6.selectBasketOutcomes);
        const saveAny = yield (0, effects_1.select)(selectors_6.selectCoefficientStatusOnChanged);
        const currentAppliedCouponId = yield (0, effects_1.select)(selectors_6.selectBasketAppliedCoupon);
        const locale = yield (0, effects_1.select)(selectors_3.selectCurrentLangCode);
        const basketProperties = {
            saveAny,
            accountId,
            appliedCouponId: currentAppliedCouponId,
            locale,
        };
        const validationImprovementsEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.BASKET_VALIDATION_IMPROVEMENTS);
        if (validationImprovementsEnabled) {
            yield (0, validation_1.validateBasketInputSaga)();
        }
        const isBasketValid = validationImprovementsEnabled
            ? yield (0, effects_1.select)(selectors_6.selectIsValidBasketInput)
            : yield (0, validation_1.basketValidation)();
        if (isBasketValid) {
            const amount = yield (0, effects_1.select)(selectors_6.selectCurrentBetAmount);
            // we update balance if we do not use bonus coupons
            if (!currentAppliedCouponId) {
                yield (0, effects_1.put)(slice_1.accountProviderActions.updateBalance({
                    adjustment: -amount,
                    bonusWallet,
                }));
            }
            yield (0, effects_1.call)(makeBetByType[currentBetTypeTab], {
                basketProperties,
                outcomes,
                bonusWallet,
            });
            yield (0, effects_1.put)(slice_4.basketProviderActions.makeBetSuccess());
        }
        else {
            yield (0, effects_1.put)(slice_4.basketProviderActions.stopMakingBet());
        }
    }
    catch (errors) {
        const error = (0, errors_1.getErrorOrUnknown)(errors);
        yield (0, effects_1.put)(slice_4.basketProviderActions.makeBetError(error));
        const errorHandleImprovementsEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.BASKET_ERROR_HANDLE_IMPROVEMENTS);
        if (errorHandleImprovementsEnabled) {
            if ((0, errors_1.isAxiosError)(errors)) {
                yield (0, validation_1.handleBackEndErrors)(errors);
            }
        }
        else {
            yield (0, validation_1.basketHandleBackEndErrors)(errors);
        }
        console.error(error);
    }
}
function* makeBetSuccessSaga() {
    var _a;
    yield (0, effects_1.put)(slice_4.basketProviderActions.setShowMakeBasketSuccessMessage(true));
    const config = yield (0, effects_1.select)(selectors_2.selectConfig);
    yield (0, effects_1.delay)(config.BASKET_SUCCESS_SWITCH_DELAY);
    // update list of loyalty after successfully using bonus coupon
    yield (0, effects_1.put)(slice_1.accountProviderActions.fetchLoyalty());
    yield (0, effects_1.put)(slice_4.basketProviderActions.setShowMakeBasketSuccessMessage(false));
    const skipResetBasketState = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.SKIP_RESET_BASKET_STATE);
    const shouldSkipBasketState = !skipResetBasketState;
    if (shouldSkipBasketState) {
        const currentBetTypeTab = yield (0, effects_1.select)(selectors_6.selectBasketBetTypeTab);
        const isOrdinarBet = currentBetTypeTab === types_2.EBetTypes.Ordinar;
        const isSaveEmptyBasketOutcomes = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.SAVE_EMPTY_ORDINAR_BASKET_OUTCOMES);
        yield (0, effects_1.put)(slice_4.basketProviderActions.resetState({
            saveUnSubmittedOutcomes: isOrdinarBet && isSaveEmptyBasketOutcomes,
        }));
    }
    else {
        yield (0, effects_1.put)(slice_4.basketProviderActions.readyForBasketReset());
    }
    yield (0, effects_1.put)(slice_4.basketProviderActions.setAppliedCoupon(null));
    /*
    Fetching the default account to update balance.
    The request is performed after the delay, so the transaction processing is completed on backend side.
     */
    yield (0, effects_1.delay)((_a = config.BASKET_BALANCE_UPDATE_DELAY) !== null && _a !== void 0 ? _a : 0);
    yield (0, effects_1.put)(slice_1.accountProviderActions.getDefaultAccount());
}
function* makeBetErrorSaga() {
    yield (0, effects_1.put)(slice_1.accountProviderActions.getDefaultAccount()); // Fetching the default account to update balance
}
function* makeBetOrdinar({ basketProperties, outcomes, bonusWallet, }) {
    // ordinar amounts can be empty until get success basket request
    const ordinarOutcomesAmounts = yield (0, effects_1.select)(selectors_6.selectOrdinarOutcomesAmounts);
    const items = outcomes.map((outcome) => {
        var _a;
        return ({
            outcomes: [
                {
                    outcomeId: outcome.id,
                    coefficient: outcome.probability.odd,
                },
            ],
            systemSize: 0,
            bet: (0, format_1.adjustAmountForBackend)((_a = ordinarOutcomesAmounts[outcome.id]) !== null && _a !== void 0 ? _a : 0),
            betType: betweb_openapi_axios_1.BetType.Ordinar,
            bonusWallet,
        });
    });
    yield (0, effects_1.call)(api_1.makeBet, {
        newBetList: { ...basketProperties, items },
        locale: basketProperties.locale,
    });
}
function* makeBetExpress({ basketProperties, outcomes, bonusWallet, }) {
    const { amount } = yield (0, effects_1.select)(selectors_6.selectExpressProperties);
    const items = (0, basket_1.mapNewBetListItems)({
        outcomes,
        betAmount: (0, format_1.adjustAmountForBackend)(amount),
        systemSize: 0,
        betType: types_2.EBetTypes.Express,
        bonusWallet,
    });
    // TODO: Remove after PLAT-1038 will be released
    let coefMultiplier;
    const featureFlag = yield (0, effects_1.select)(selectors_2.selectFeatureFlags);
    if (featureFlag === null || featureFlag === void 0 ? void 0 : featureFlag.BONUS_ON_EXPRESS_ENABLED) {
        coefMultiplier = yield (0, effects_1.select)(selectors_6.selectBonusOnExpress);
    }
    yield (0, effects_1.call)(api_1.makeBet, {
        newBetList: { ...basketProperties, items, coefMultiplier },
        locale: basketProperties.locale,
    });
}
function* makeBetSystem({ basketProperties, outcomes, bonusWallet, }) {
    const betAmount = yield (0, effects_1.select)(selectors_6.selectSystemAmount);
    const systemSize = yield (0, effects_1.select)(selectors_6.selectSystemSize);
    const items = (0, basket_1.mapNewBetListItems)({
        outcomes,
        betAmount: (0, format_1.adjustAmountForBackend)(betAmount),
        systemSize,
        betType: types_2.EBetTypes.System,
        bonusWallet,
    });
    yield (0, effects_1.call)(api_1.makeBet, {
        newBetList: { ...basketProperties, items },
        locale: basketProperties.locale,
    });
}
function* addOutcomeToBasketSaga({ payload: { eventProbability, eventId }, }) {
    (0, invariant_1.invariant)(eventProbability, '[addOutcomeToBasketSaga] Missing eventProbability');
    const outcomeKey = (0, utils_2.getBasketOutcomeKey)({
        probability: eventProbability,
        event: { id: eventId },
    });
    try {
        const existingOutcomeInBasket = yield (0, effects_1.select)((state) => (0, selectors_6.selectBasketOutcomeByKey)(state, outcomeKey));
        if (existingOutcomeInBasket) {
            yield (0, effects_1.put)(slice_4.basketProviderActions.deleteBasketOutcome({
                outcomeId: existingOutcomeInBasket.id,
                outcomeKey,
            }));
        }
        else {
            const event = yield (0, effects_1.select)((state) => {
                var _a;
                return (_a = (0, selectors_5.selectEventById)(state, eventId)) !== null && _a !== void 0 ? _a : (0, selectors_4.selectSearchEventsItem)(state, eventId);
            });
            const outcomeIdentifier = (0, basket_1.getNewBasketOutcome)({
                eventProbability,
                event,
            });
            const accountId = yield (0, effects_1.select)(selectors_1.selectAccountId);
            yield (0, effects_1.put)(slice_4.basketProviderActions.addLoadingOutcomeKey(outcomeKey));
            yield (0, effects_1.put)(slice_4.basketProviderActions.updateBasketOutcomes({
                outcomeIdentifier,
                accountId,
                outcomeKey,
            }));
        }
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error(error);
        yield (0, effects_1.put)(slice_4.basketProviderActions.updateBasketOutcomesError(e));
        yield (0, effects_1.put)(slice_4.basketProviderActions.clearLoadingOutcomeKey(outcomeKey));
        // TODO add error to UI
    }
}
function* updateBasketOutcomesSaga({ payload: { outcomeIdentifier, accountId, outcomeKey }, }) {
    try {
        const locale = yield (0, effects_1.select)(selectors_3.selectCurrentLangCode);
        const outcomesLength = yield (0, effects_1.select)(selectors_6.selectBasketOutcomesLength);
        const singleAmount = yield (0, effects_1.select)(selectors_6.selectOrdinarSingleAmount);
        const { data: basket } = yield (0, effects_1.call)(api_2.updateBasketOutcomes, {
            outcomeIdentifier,
            accountId,
            locale,
        });
        yield (0, effects_1.put)(slice_4.basketProviderActions.clearLoadingOutcomeKey(outcomeKey));
        // After adding a new outcome in basket, we should reset applied coupon
        yield (0, effects_1.call)(resetAppliedCoupon);
        yield (0, effects_1.put)(slice_4.basketProviderActions.updateBasketOutcomesSuccess({ basket }));
        if (!outcomesLength) {
            // Show Basket Modal in mobile
            yield (0, effects_1.put)(slice_4.basketProviderActions.toggleMobileModal({
                modalType: types_2.EMobileModalType.OUTCOMES,
            }));
        }
        if (singleAmount !== '') {
            yield (0, effects_1.call)(validation_1.validateBasketInputSaga);
        }
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error(error);
        yield (0, effects_1.put)(slice_4.basketProviderActions.clearLoadingOutcomeKey(outcomeKey));
        // TODO add error to UI
    }
}
function* deleteBasketSaga() {
    try {
        const accountId = yield (0, effects_1.select)(selectors_1.selectAccountId);
        yield (0, effects_1.call)(api_2.deleteBasket, { accountId });
        yield (0, effects_1.put)(slice_4.basketProviderActions.deleteBasketSuccess());
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error(error);
        // TODO add error to UI
    }
}
function* deleteBasketOutcomeSaga({ payload: { outcomeId, outcomeKey: payloadOutcomeKey }, }) {
    const outcomeKey = payloadOutcomeKey !== null && payloadOutcomeKey !== void 0 ? payloadOutcomeKey : (yield (0, effects_1.select)(selectors_6.getOutcomeKeyByOutcomeId, outcomeId));
    try {
        yield (0, effects_1.put)(slice_4.basketProviderActions.addLoadingOutcomeKey(outcomeKey));
        // const basketId = yield select(selectBasketId)
        const accountId = yield (0, effects_1.select)(selectors_1.selectAccountId);
        const outcomesLength = yield (0, effects_1.select)(selectors_6.selectBasketOutcomesLength);
        const betType = yield (0, effects_1.select)(selectors_6.selectBasketBetTypeTab);
        // if we have only one outcome in basket, we should delete the whole basket
        if (outcomesLength === 1) {
            yield (0, effects_1.put)(slice_4.basketProviderActions.deleteBasket());
            yield (0, effects_1.put)(slice_4.basketProviderActions.deleteBasketSuccess());
        }
        else {
            yield (0, effects_1.call)(api_2.deleteBasketOutcome, { accountId, outcomeId });
            if ((0, basket_2.shouldResetAmountsAfterDelete)(outcomesLength, betType)) {
                yield (0, effects_1.put)(slice_4.basketProviderActions.resetOutcomesAmounts());
                yield (0, effects_1.put)(slice_4.basketProviderActions.resetOrdinarErrors());
            }
            if ((0, basket_2.shouldResetSingleAmountAfterDelete)(outcomesLength, betType)) {
                yield (0, effects_1.put)(slice_4.basketProviderActions.resetSingleAmount());
            }
            // we should update basket if we delete the dependent outcome
            // TODO appliedCoupon perhaps there is a better way to update appliedCouponIds
            // TODO Ask backend to extend OUTCOMES DELETE endpoint to return updated basket (with updated appliedCouponIds !!!)
            // TODO remove after backend their task and update for isDependentEvent
            yield (0, effects_1.call)(resetAppliedCoupon);
            yield (0, effects_1.put)(slice_4.basketProviderActions.getBasket());
            // if (isDependentEvent) {
            //   yield put(basketProviderActions.getBasket())
            // }
            yield (0, effects_1.put)(slice_4.basketProviderActions.deleteBasketOutcomeSuccess({ outcomeId }));
            const competitorsConstraintEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.COMPETITORS_CONSTRAINT_ENABLED);
            if (competitorsConstraintEnabled) {
                yield (0, effects_1.put)(slice_4.basketProviderActions.filterRejectedIds());
                yield (0, validation_1.validateBasketInputSaga)();
            }
        }
        yield (0, effects_1.put)(slice_4.basketProviderActions.clearLoadingOutcomeKey(outcomeKey));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error(error);
        yield (0, effects_1.put)(slice_4.basketProviderActions.deleteBasketOutcomeError(error));
        yield (0, effects_1.put)(slice_4.basketProviderActions.clearLoadingOutcomeKey(outcomeKey));
        // TODO add error to UI
    }
}
function* getBasketSaga() {
    try {
        const locale = yield (0, effects_1.select)(selectors_3.selectCurrentLangCode);
        const accountId = yield (0, effects_1.select)(selectors_1.selectAccountId);
        const { data: { outcomes, dependentEventGroups, constraints, appliedCouponIds }, } = yield (0, effects_1.call)(api_2.getBasket, { accountId, locale });
        yield (0, effects_1.fork)(processBasketSideEffectsSaga, outcomes);
        yield (0, effects_1.put)(slice_4.basketProviderActions.getBasketSuccess({
            outcomes,
            dependentEventGroups,
            constraints,
            appliedCouponIds,
        }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error(error);
        yield (0, effects_1.put)(slice_4.basketProviderActions.getBasketError(e));
        // TODO add error to UI
    }
}
function* processBasketSideEffectsSaga(outcomes) {
    yield (0, effects_1.fork)(processBasketPlayersSaga, outcomes);
}
// fetching player names to show in basket by ids from outcomes
function* processBasketPlayersSaga(outcomes) {
    const playerIds = (0, utils_1.getPlayerIdsForBasket)(outcomes);
    if (playerIds.length > 0) {
        yield (0, effects_1.put)(slice_2.playersProviderActions.fetchPlayers({ playersIds: playerIds }));
    }
}
function* setCoefficientStatusOnChangedSaga() {
    const status = yield (0, effects_1.select)(selectors_6.selectCoefficientStatusOnChanged);
    yield (0, effects_1.put)(slice_3.storageProviderActions.setItem({
        key: 'coefficientStatusOnChanged',
        value: status,
    }));
}
function* setAppliedCouponSaga() {
    const appliedCouponId = yield (0, effects_1.select)(selectors_6.selectBasketAppliedCoupon);
    const currentAppliedCouponAmount = yield (0, effects_1.select)((state) => (0, selectors_1.selectLoyaltyAmountById)(state, appliedCouponId));
    const isBonusWallet = yield (0, effects_1.select)(selectors_6.selectBasketBonusWallet);
    // reset bonus wallet if we choose bonus coupon
    if (isBonusWallet) {
        yield (0, effects_1.put)(slice_4.basketProviderActions.resetBonusWallet());
    }
    yield (0, effects_1.put)(slice_4.basketProviderActions.resetBasketErrors());
    if (currentAppliedCouponAmount) {
        yield (0, effects_1.put)(slice_4.basketProviderActions.setAppliedCouponAmount(String(currentAppliedCouponAmount)));
    }
    else {
        yield (0, effects_1.put)(slice_4.basketProviderActions.setAppliedCouponAmount(''));
        yield (0, effects_1.put)(slice_4.basketProviderActions.resetOutcomesAmounts());
        yield (0, effects_1.put)(slice_4.basketProviderActions.resetOrdinarErrors());
    }
    yield (0, effects_1.call)(handleBasketInputChangedSaga);
}
function* setBonusWalletSaga() {
    const appliedCouponId = yield (0, effects_1.select)(selectors_6.selectBasketAppliedCoupon);
    // reset bonus coupon if we choose bonus wallet
    if (appliedCouponId) {
        yield (0, effects_1.put)(slice_4.basketProviderActions.setAppliedCoupon(null));
        yield (0, effects_1.put)(slice_4.basketProviderActions.activateBonusWallet());
    }
    yield (0, effects_1.call)(handleBasketInputChangedSaga);
}
function* resetAppliedCoupon() {
    const appliedCouponId = yield (0, effects_1.select)(selectors_6.selectBasketAppliedCoupon);
    if (appliedCouponId) {
        yield (0, effects_1.put)(slice_4.basketProviderActions.setAppliedCoupon(null));
    }
}
function* handleBetTypeTabChangeSaga() {
    // reset bonus coupon if we change bet type tab
    yield (0, effects_1.put)(slice_4.basketProviderActions.setAppliedCoupon(null));
    yield (0, effects_1.put)(slice_4.basketProviderActions.resetSingleAmount());
}
function* handleBetTypeTabChangeMobileSaga() {
    yield (0, effects_1.put)(slice_4.basketProviderActions.setAppliedCoupon(null));
    yield (0, effects_1.put)(slice_4.basketProviderActions.resetSingleAmount());
    yield (0, validation_1.basketHandleBetTypeTabChangeMobileErrors)();
}
function* basketProviderSaga() {
    yield (0, effects_1.all)([
        (0, effects_1.takeLatest)(slice_4.basketProviderActions.setOrdinarAmount, handleBasketInputChangedSaga),
        (0, effects_1.takeLatest)(slice_4.basketProviderActions.setSingleAmountForEachOutcome, handleBasketInputChangedSaga),
        (0, effects_1.takeLatest)(slice_4.basketProviderActions.setExpressAmount, handleBasketInputChangedSaga),
        (0, effects_1.takeLatest)(slice_4.basketProviderActions.setSystemAmount, handleBasketInputChangedSaga),
        (0, effects_1.takeLatest)(slice_4.basketProviderActions.setBonusWallet, setBonusWalletSaga),
        (0, effects_1.takeLatest)(slice_4.basketProviderActions.makeBet.type, makeBetSaga),
        (0, effects_1.takeLatest)(slice_4.basketProviderActions.makeBetSuccess.type, makeBetSuccessSaga),
        (0, effects_1.takeLatest)(slice_4.basketProviderActions.makeBetError.type, makeBetErrorSaga),
        (0, effects_1.takeLatest)(slice_4.basketProviderActions.addOutcomeToBasket.type, addOutcomeToBasketSaga),
        // takeLatest(basketProviderActions.createBasket.type, createBasketSaga),
        (0, effects_1.takeEvery)(slice_4.basketProviderActions.updateBasketOutcomes.type, updateBasketOutcomesSaga),
        (0, effects_1.takeLatest)(slice_4.basketProviderActions.deleteBasket.type, deleteBasketSaga),
        (0, effects_1.takeEvery)(slice_4.basketProviderActions.deleteBasketOutcome.type, deleteBasketOutcomeSaga),
        (0, effects_1.takeLatest)(slice_4.basketProviderActions.getBasket.type, getBasketSaga),
        // takeLatest(basketProviderActions.getBaskets.type, getBasketsSaga),
        (0, effects_1.takeLatest)(slice_4.basketProviderActions.handleBetTypeTabChangeMobile, handleBetTypeTabChangeMobileSaga),
        (0, effects_1.takeLatest)(slice_4.basketProviderActions.triggerBasketOutcomesLength, validateExpressSystemErrorsSaga),
        (0, effects_1.takeLatest)(slice_4.basketProviderActions.setCoefficientStatusOnChanged, setCoefficientStatusOnChangedSaga),
        (0, effects_1.takeLatest)(slice_4.basketProviderActions.setAppliedCoupon, setAppliedCouponSaga),
        (0, effects_1.takeLatest)(slice_4.basketProviderActions.handleBetTypeTabChange, handleBetTypeTabChangeSaga),
    ]);
}
//# sourceMappingURL=saga.js.map